// Frontend API client for the private help center ("Private KB").
// Uses the authenticated dashboard HTTP client (window.axios) so the access
// ticket is issued against the logged-in user + current account.
const http = () => window.axios;

const accountBase = accountId => `/api/v1/accounts/${accountId}`;

// List portals the current user can see (backend scopes to the account).
export const fetchPortals = async accountId => {
  const { data } = await http().get(`${accountBase(accountId)}/portals`);
  return data?.payload || [];
};

// Issue a short-lived signed cookie that unlocks /hc for this account.
export const issueAccessTicket = async accountId => {
  const { data } = await http().post(
    `${accountBase(accountId)}/hc_access_tickets`
  );
  return data;
};
